export const fetchData = async (accessToken, apiEndpoint, data_received, process_data) => {
    // data fetching here
    // Make an API call and populate data array
    var apiUrl = process.env.REACT_APP_api_address + apiEndpoint

    // if(!apiUrl.includes('localhost')) apiUrl += '?code=AWEQ1AcjBJ93p795-zj23J7AjvGeobIJ9f3sAB2_SzowAzFuxStQTw%3D%3D'
    if (process.env.NODE_ENV === 'development')
        console.log(apiUrl);

    fetch(apiUrl, { method: "GET", headers: { Authorization: `Bearer ${accessToken}` } })
        .then(data_received)
        .then(process_data)
        .catch((error) => {
            console.error('Error fetching data:', error);
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
        });
}

export const putData = async (accessToken, apiEndpoint, data_received, process_data, body_contents) => {
    var apiUrl = process.env.REACT_APP_api_address + apiEndpoint

    fetch(`${apiUrl}`, {
        method: 'PUT',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: body_contents
    })
    .then(data_received)
    .then(process_data)
    .catch((error) => {
        console.error('Error fetching data:', error);
    })
    .catch((error) => {
        console.error('Error fetching data:', error);
    });;
}

export const postData = async (accessToken, apiEndpoint, data_received, process_data, body_contents) => {
    var apiUrl = process.env.REACT_APP_api_address + apiEndpoint

    fetch(`${apiUrl}`, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: body_contents
    })
    .then(data_received)
    .then(process_data)
    .catch((error) => {
        console.error('Error fetching data:', error);
    })
    .catch((error) => {
        console.error('Error fetching data:', error);
    });;
}

export const deleteData = async (accessToken, apiEndpoint, data_received, process_data, body_contents) => {
    var apiUrl = process.env.REACT_APP_api_address + apiEndpoint

    fetch(`${apiUrl}`, {
        method: 'DELETE',
        headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        },
        body: body_contents
    })
    .then(data_received)
    .then(process_data)
    .catch((error) => {
        console.error('Error fetching data:', error);
    })
    .catch((error) => {
        console.error('Error fetching data:', error);
    });;
}

//get access token
export const getAccessToken = async (instance, accounts) => {
    // if (process.env.NODE_ENV === 'development' )
    //     return '';
    const scopes = ["api://fce59d1b-98af-480d-9eff-30d1518197d8/user_impersonation"];
    // const scopes = ["api://fce59d1b-98af-480d-9eff-30d1518197d8/Api.ReadWrite"];
    try {
        // Attempt to acquire access token silently
        const response = await instance.acquireTokenSilent({
            // scopes: ["api://fce59d1b-98af-480d-9eff-30d1518197d8/user_impersonation"],
            scopes: scopes,
            account: accounts[0], // Assuming the first account is used
        });

        // setAccessToken(response.accessToken);
        return response.accessToken;
    } catch (silentError) {
        console.log("Failed to acquire access token silently:", silentError);

        // If silent acquisition fails, attempt interactive acquisition
        try {
            const interactiveResponse = await instance.acquireTokenRedirect({
                // scopes: ["api://fce59d1b-98af-480d-9eff-30d1518197d8/user_impersonation"],
                scopes: scopes,
            });

            // setAccessToken(interactiveResponse.accessToken);
            return interactiveResponse.accessToken;
        } catch (interactiveError) {
            console.log("Failed to acquire access token interactively:", interactiveError);
        }
    }
};